/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, handleStepBack, setFnolReducer, saveDamageSelected, submitFNOL } from '../../../actions/claimSubmitActions';
import { isMobile } from 'react-device-detect';
import { showFNOLTakePhoto } from '../../../actions/modalActions';

class FnolStep5Sub1 extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            damageExtraText: this.props.claimSubmit.extraDescription,
            carDamageExtras: ["Undercarriage damage", "Interior", "Airbag popped", "Sunroof", "Roof", "Locks"],
            mbDamageExtras: ["Seat", "Sprocket", "Gas tank", "Frame", "Passenger seat", "Chain", "Engine", "Drive train", "Instruments", "Suspension"],
        }
        this.checkDamageExtras = this.checkDamageExtras.bind(this);
        this.handleChangeExtraText = this.handleChangeExtraText.bind(this);
        this.checkChecked = this.checkChecked.bind(this);
        this.setClaimDamagePhotoTypes = this.setClaimDamagePhotoTypes.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleStepBack = this.handleStepBack.bind(this);
    }

    async handleStepBack() {
        this.props.dispatchHandleStepBack();
    }

    handleSubmit() {
        this.setState({ DescriptionWhatSubmitted: true });
        this.props.dispatchAction(setFnolReducer("extraDescription", this.state.damageExtraText))

        if (!this.props.ssp.drivableClaimsEnabled) {
            if (isMobile) {
                this.props.dispatchShowFNOLTakePhoto();
            }
            else {
                this.props.dispatchSubmitFNOL();
                this.props.dispatchHandleNextStep();
            }
        } else {
            if (isMobile) {
                this.props.dispatchShowFNOLTakePhoto();
            }
            else {
                this.props.dispatchHandleNextStep();
            }
        }
        window.scrollTo(0, 0);
    }

    async setClaimDamagePhotoTypes(data: any) {
        this.props.dispatchSaveDamageSelected(data.description)
    }

    checkChecked(e: any) {
        var set = this.props.claimSubmit.selectedDamagePhotoTypes.find((el => el.description == e));
        if (set) {
            return ("/my-policy/Images/Claims/grey-checkmark-checked.png");
        } else {
            return ("/my-policy/Images/Claims/grey-checkmark-unchecked.png");
        }
    }

    handleChangeExtraText(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
    }

    checkDamageExtras(desc, isCar) {
        if (isCar) {
            return this.state.carDamageExtras.indexOf(desc) >= 0 ? true : false;
        }
        else {
            return this.state.mbDamageExtras.indexOf(desc) >= 0 ? true : false;
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    public render() {
        //Take photo step
        let extraDamagesList = <div></div>;
        extraDamagesList = this.props.claimSubmit.claimDamagePhotoTypes.filter((photoType => photoType.location === "special"))
            .map((photoType) => {
                return <>
                    <div className="row noma cover-divider-fnol fnol-damage-report-extras-items-holder align-items-center cursor-pointer" onClick={() => this.setClaimDamagePhotoTypes(photoType)} title={photoType.description}>
                        <div className="col nopa">
                            <p className="coverItems">{photoType.description}</p>
                        </div>
                        <div className="greyChecks align-self-center">
                            <img alt="photo-image" id={photoType.description} className={photoType.description} src={photoType.isSelected ? "/my-policy/Images/Claims/grey-checkmark-checked.png" : "/my-policy/Images/Claims/grey-checkmark-unchecked.png"}  />
                        </div>
                    </div>
                    </>
            });
        return (
            <div className="col ssp-container-fnol-damage-report ssp-container-fnol-damage-report-extra ssp-container-fnol-step-header-padding">
                <div className="row noma">
                    <div className="col-12 nopa ssp-header-fnol-damage-report">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src={'/my-policy/Images/Claims/Numbers/number-' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red-32x32px.svg'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                            </div>
                            <div className="col fnol-step-header-title-area">
                                <h3>Damage report: Extras</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row noma">
                    <div className="col-12 fnol-steps-info-section-holder">
                        <hr className="hr-minus21px" />
                        <p className="fnol-damage-report-intro-p">
                            Were any of these areas damaged in the process (if not, just select 'Next')
                        </p>
                    </div>
                    <div className="col nopa">
                        <>
                            {extraDamagesList}
                        </>
                        <div className='mt-25px mobile-mt-20px'>
                            <p className="noma mb-15px">
                                Can't find what you want on this&nbsp;
                                <br className="mobile-br" />
                                list? Specify which extras were&nbsp;
                                <br className="mobile-br" />
                                damaged, here:
                            </p>
                            <div className="fnol-damage-report-extras-textarea-div">
                                <textarea id="DamageExtrasText" name="damageExtraText" rows={4} cols={50} className="ssp-form-textarea" placeholder="Tap here to start typing" value={this.state.damageExtraText} onChange={this.handleChangeExtraText} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row noma fnol-steps-buttonholder-row">
                    <div className="col nopa fnol-steps-buttonholder">
                        <button className="btn btn-solid-red fnol-buttonreverse-button-next" disabled={!this.props.claimSubmit.hasDamageSelected} onClick={this.handleSubmit}>Next</button>
                        <button className="btn btn-outline-red fnol-buttonreverse-button-back" onClick={this.handleStepBack}>Back</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
        ssp:state.ssp
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatchSaveDamageSelected: (description) => dispatch(saveDamageSelected(description)),
        dispatchSubmitFNOL: () => dispatch(submitFNOL()),
        dispatchShowFNOLTakePhoto: () => dispatch(showFNOLTakePhoto()),
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FnolStep5Sub1)